import React from 'react'
import lock from '../../Assets/images/asset-cta.jpg'
import Constant from '../../Constant'
import Button from '../SelectValue/Button'
import FadeInSection from '../FadeInSection'

function Unlock() {
  return (
    <FadeInSection>
      <div className='px-6 sm:px-24 grid pb-20 pt-20 sm:grid-cols-2 md:grid-cols-3 gap-5'>
        <div className='order-last sm:order-first'>
          <img
            src={lock}
            className="mx-auto w-64 sm:w-80 md:w-96 h-auto object-contain"
            alt="Unlock image"
          />        </div>
        <div className='sm:mb-0 mb-6 md:col-span-2'>
          <h1 className='text-[24px] font-[400] mb-5 sm:text-[44px] text-text-color1'>
            Start Owning Today - <span className={Constant.linearColor}>100% Halal Financing.</span>
          </h1>
          <p className='text-text-color1 font-normal text-[16px] sm:text-[18px] mb-5'>
            Apply in minutes, get approved fast, and pay back on terms that align with your values. No interest. No hidden costs.
          </p>
          <Button name="Apply Now" />
        </div>
      </div>
    </FadeInSection>
  )
}

export default Unlock
